module.exports = __webpack_public_path__ + "static/media/mobileScreenshot06.b6352080.jpg";